<template>
  <div id="addUser">
    <div class="text-right mb-2">
      <b-button @click="status = true" variant="success">Add Invoice</b-button>
    </div>
    <!-- Add Modal -->
    <b-modal
      v-model="status"
      id="modal-center"
      centered
      title="Add Invoice"
      ok-title="Add"
      :ok-disabled="loading"
      @ok="add"
    >
      <!-- Loading -->
      <div v-if="loading" class="text-center">
        <b-spinner style="width: 3rem; height: 3rem" />
      </div>
      <!-- User Content -->
      <div v-else>
        <!-- User info -->
        <div
          v-if="userInfo"
          class="d-flex align-items-center justify-content-between mb-1 p-75 rounded"
          style="background: rgba(115, 103, 240, 0.08); border: 1px solid rgba(115, 103, 240, 0.2);"
        >
          <div>
            <strong>{{ userInfo.username }}</strong>
            <br />
            <small class="text-muted">{{ userInfo.email }}</small>
          </div>
          <div class="text-right">
            <small class="text-muted">Credit</small>
            <br />
            <strong>${{ parseFloat(userInfo.credit || 0).toFixed(2) }}</strong>
          </div>
        </div>

        <!-- Amount -->
        <b-form-group label="Amount" label-for="amount">
          <cleave
            id="number"
            v-model="form.amount"
            class="form-control"
            :raw="false"
            :options="{ numeral: true }"
            autocomplete="off"
            placeholder="101,000"
          />
        </b-form-group>

        <!-- textarea EXTRA -->
        Extra info/note
        <b-input-group label="Extra info/note" label-for="extra">
          <b-form-textarea
           v-model="form.extra" 
           />
        </b-input-group>

        <!-- Status -->
        <b-form-group label="Status">
          <b-form-checkbox-group
            @input="(v) => (form.status = [v[v.length - 1]])"
            v-model="form.status"
            :options="options"
            switches
            stacked
          />
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import {
  BButton,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormCheckboxGroup,
  BFormTextarea,
} from "bootstrap-vue";
import Invoice from "@/services/invoice.service";
import UserService from "@/services/user.service";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Cleave from "vue-cleave-component";

export default {
  data: () => ({
    loading: false,
    status: false,
    userInfo: null,
    options: [
      { text: "Paid", value: "PAID" },
      { text: "Un-paid", value: "UNPAID" },
      { text: "Deduct", value: "DEDUCT" },
    ],
    form: {
      amount: null,
      extra: null,
      status: [],
    },
  }),
  async mounted() {
    const userId = this.$route.params.user_id;
    if (userId) {
      try {
        this.userInfo = await UserService.specific(userId);
      } catch {
        // silent — modal still works without user info
      }
    }
  },
  methods: {
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copied!",
          icon: "CopyIcon",
          variant: "success",
        },
      });
    },
    showSummaryPopup(html) {
      if (!html) return;
      Vue.prototype.$swal({
        title: "Invoice Added",
        html: `<div id="invoice-summary" style="text-align:left;">${html.replace(/\n/g, '<br>')}</div>`,
        confirmButtonText: "Copy & Close",
        showCancelButton: true,
        cancelButtonText: "Close",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
        preConfirm: () => {
          const el = document.getElementById("invoice-summary");
          if (el) this.copyToClipboard(el.innerText);
        },
      });
    },
    async add(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault();
      if (this.loading) return;
      this.loading = true;
      try {
        const form = {
          amount: +this.form.amount.replaceAll(",", ""),
          status: this.form.status[0] || null,
          user_id: +this.$route.params.user_id,
          extra: this.form.extra,
        };
        const resData = await Invoice.add(form);
        this.status = false;
        this.$emit("added");

        // Refresh user credit after adding invoice
        if (this.userInfo) {
          try {
            this.userInfo = await UserService.specific(this.$route.params.user_id);
          } catch {
            // silent
          }
        }

        this.$nextTick(() => {
          this.showSummaryPopup(resData);
        });
      } catch (e) {
        const msg =
          e.response?.status === 422
            ? Object.values(e.response.data.errors)[0][0]
            : "Something went wrong, please try again";
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Failed to add",
            icon: "XIcon",
            text: msg,
            variant: "danger",
          },
        });
      }
      this.loading = false;
    },
  },
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckboxGroup,
    // eslint-disable-next-line vue/no-unused-component
    ToastificationContent,
    Cleave,
    BFormTextarea,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.country-list {
  width: 100%;
}
</style>
